<template>
  <div class="punctuate-rules">
    <div class="rule-type">
      <el-radio-group v-model="rType" @change="handleRuleTypeChange">
       <div class="rule-item">
          <el-radio :label="1">{{$t('newProjectV2.byParagraphBreak')}}</el-radio>
        </div>
        <div class="rule-item">
          <el-radio :label="0">{{$t('newProjectV2.bySentBreak')}}</el-radio>
        </div>
        <div class="rule-item">
          <el-radio :label="2">{{$t('newProjectV2.customRule')}}</el-radio>
        </div>
      </el-radio-group>
    </div>
    <div class="rule-header" v-show="rType === 2">
      <el-button type="primary" @click="handleCreateRule">{{$t('newProjectV2.createRule')}}</el-button>
      <el-button class="download" @click="handleDownload">{{$t('newProjectV2.downloadTemplate')}}</el-button>
    </div>
    <div class="rule-table" v-show="rType === 2">
      <div class="table-box">
        <el-table
          :data="punctuateRuleList"
          ref="multipleTable"
          tooltip-effect="dark"
          header-row-class-name="customHeader"
          border
        >
          <el-table-column :label="$t('newProjectV2.serialNumber')" align="center" width="55">
            <template slot-scope="{ $index }">
              {{$index + 1}}
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('newProjectV2.enable')"
            align="center"
            width="70"
          >
            <template slot-scope="{ row }">
              <el-radio v-model="ruleID" @change="radioChange(row.id)" :label="row.id"><span></span></el-radio>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('newProjectV2.ruleName')"
            align="center"
            prop="ruleName"
            :show-overflow-tooltip='true'
          ></el-table-column>
          <el-table-column
            :label="$t('newProjectV2.language')"
            align="center"
            :show-overflow-tooltip='true'
          >
            <template slot-scope="{ row }">
              {{ $i18n.locale === 'zh' ? row.langName : $langCase[row.langCode] }}
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('newProjectV2.operate')"
            align="center"
            class-name="operate"
          >
            <template slot-scope="{ row }">
              <el-tooltip effect="dark" :content="$t('newProjectV2.edit')" placement="top">
                <i class="icon-edit" @click="handleEdit(row)"></i>
              </el-tooltip>
              <el-tooltip effect="dark" v-if="row.type === 0" :content="$t('newProjectV2.config')" placement="top">
                <i class="icon-setting" @click="handleConfig(row)"></i>
              </el-tooltip>
              <el-tooltip effect="dark" :content="$t('newProjectV2.del')" placement="top">
                <i class="icon-delete" @click="handleDelete(row.id)"></i>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <div class="ruleTips"  v-if="punctuateRuleListNotMatch.length > 0">{{ $t('newProjectV2.ruleTips') }}</div>
        <el-table
          v-if="punctuateRuleListNotMatch.length > 0"
          :data="punctuateRuleListNotMatch"
          ref="multipleTable"
          tooltip-effect="dark"
          header-row-class-name="customHeader"
          :show-header="false"
          border
        >
          <el-table-column :label="$t('newProjectV2.serialNumber')" align="center" width="55">
            <template slot-scope="{ $index }">
              {{$index + 1}}
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('newProjectV2.enable')"
            align="center"
            width="70"
          >
          <!-- 不可选 -->
            <template slot-scope="{ row }">
              {{ $t('newProjectV2.notChoose') }}
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('newProjectV2.name')"
            align="center"
            prop="ruleName"
            :show-overflow-tooltip='true'
          ></el-table-column>
          <el-table-column
            :label="$t('newProjectV2.language')"
            align="center"
            :show-overflow-tooltip='true'
          >
            <template slot-scope="{ row }">
              {{ $i18n.locale === 'zh' ? row.langName : $langCase[row.langCode] }}
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('newProjectV2.operate')"
            align="center"
            class-name="operate"
          >
            <template slot-scope="{ row }">
              <el-tooltip effect="dark" :content="$t('newProjectV2.edit')" placement="top">
                <i class="icon-edit" @click="handleEdit(row)"></i>
              </el-tooltip>
              <el-tooltip effect="dark" v-if="row.type === 0" :content="$t('newProjectV2.config')" placement="top">
                <i class="icon-setting" @click="handleConfig(row)"></i>
              </el-tooltip>
              <el-tooltip effect="dark" :content="$t('newProjectV2.del')" placement="top">
                <i class="icon-delete" @click="handleDelete(row.id)"></i>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <DelDialog
      width="480px"
      :dialogVisible="delVisible"
      @handleClose="deleteCancel"
      @handleConfirm="handleDel"
    >
      {{$t('newProjectV2.delTip')}}
    </DelDialog>

    <CreateRule
      :visible="createVisible"
      @handleCancel="createCancel"
      @updateRule="updateRule"
    ></CreateRule>

    <EditRule
      :editRule="editRule"
      :visible="editVisible"
      @handleCancel="editCancel"
      @updateRule="updateRule"
    ></EditRule>

    <ConfigRule
      :editRule="editRule"
      :configVisible="configVisible"
      @handleCancelConfig="handleCancelConfig"
      @updateRule="updateRule"
    ></ConfigRule>
  </div>
</template>

<script>
import DelDialog from '@/components/delDialog';
import CreateRule from '@/components/projectDialog/createRule';
import EditRule from '@/components/projectDialog/editRule';
import ConfigRule from '@/components/projectDialog/configRule';

import { apiRoot } from '@/services/ajax';
import { deletePunctuateRule } from '@/services/dialogApi';

export default {
  name: 'PunctuateRule',
  props: {
    punctuateRuleList: {
      type: Array,
      default () {
        return [];
      }
    },
    punctuateRuleListNotMatch: {
      type: Array,
      default () {
        return [];
      }
    },
    ruleType: {
      type: Number,
      default () {
        return 2;
      }
    },
  },
  components: {
    DelDialog,
    CreateRule,
    EditRule,
    ConfigRule,
  },
  data () {
    return {
      ruleID: null,
      delVisible: false,
      selDelID: null,
      createVisible: false,
      editVisible: false,
      editRule: {},
      configVisible: false,
      rType: this.ruleType,
    }
  },
  methods: {
    handleRuleTypeChange (type) {
      this.$emit('ruleTypeChange', type);
    },
    handleEdit (row) {
      this.editRule = { ...row };
      this.editVisible = true;
    },
    editCancel () {
      this.editVisible = false;
    },
    handleConfig (row) {
      this.editRule = { ...row };
      this.configVisible = true;
    },
    handleCancelConfig () {
      this.configVisible = false;
    },
    handleCreateRule () {
      this.createVisible = true;
    },
    createCancel () {
      this.createVisible = false;
    },
    handleDelete (id) {
      this.selDelID = id;
      this.delVisible = true;
    },
    deleteCancel () {
      this.delVisible = false;
    },
    async handleDel () {
      this.delVisible = false;
      let { success } = await deletePunctuateRule({
        guideProgress: 0,
        id: this.selDelID,
      });
      if (!success) { return }
      this.$message({
        type: 'success',
        message: this.$t('newProjectV2.delSuccess')
      });
      this.$emit('updateRule');
    },
    updateRule () {
      this.$emit('updateRule');
    },
    radioChange () {
      this.$emit('getRuleID', this.ruleID);
    },
    handleDownload () {
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = apiRoot('/transSegmentRule/downloadTemplate');
      document.body.appendChild(link);
      link.click();
    },
  }
}
</script>

<style lang="less" scoped>
  @import "./assets/style.less";
</style>